export { default } from './PixelMap';
